import Swiper from '@iris.interactive/handcook/public/scripts/libraries/swiper-11'
import AutoHiddingNavAction from './actions/AutoHiddingNavAction'
import DropdownAction from './actions/DropdownAction'
import ToggleAction from './actions/ToggleAction'
import SliderComponent from './components/SliderComponent'

import apiFetch from '@wordpress/api-fetch'
import SliderItinerancesAction from './actions/SliderItinerancesAction'
import BurgerMenuComponent from './components/BurgerMenuComponent'
import LangMenuComponent from './components/LangMenuComponent'

document.addEventListener('DOMContentLoaded', async () => {
    new DropdownAction()
    new AutoHiddingNavAction()
    new ToggleAction()
    new SliderComponent()
    new BurgerMenuComponent()
    new SliderItinerancesAction()
    new LangMenuComponent()

    await Swiper.create('#pages-list-slider', {
        slidesPerView: '1',
        spaceBetween: 10,
        // slidesPerGroup: 1,
        loop: false,
        autoplay: true,
        // loopFillGroupWithBlank: true,
        freeMode: false,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        breakpoints: {
            650: {
                slidesPerView: '2',
                // slidesPerGroup: 2,
                spaceBetween: 30,
            },
            1200: {
                slidesPerView: '3',
                // slidesPerGroup: 2,
                spaceBetween: 30,
            },
            1450: {
                slidesPerView: '3',
                // slidesPerGroup: 2,
                spaceBetween: 40,
            },
        },
    })

    if (
        window.matchMedia('(max-width: 650px)').matches &&
        $('.itinerances__list__pages').length > 0
    ) {
        await Swiper.create('.itinerances__list__pages', {
            slidesPerView: '2',
            spaceBetween: 15,
            freeMode: true,
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
            },
        })
    }

    /* Strate instagram --------------------- */
    if ($('[data-id="social-wall"]').length > 0 && !$('[data-id="social-wall"]').is(':hidden')) {
        apiFetch({
            path: IRISCollectionCustomer.irisSsoInstagramPath,
            method: 'POST',
            data: { limit: 4 },
        })
            .then((result) => {
                $('[data-id="social-wall"]').html(result.render)
                import(
                    '@iris.interactive/handcook/public/scripts/components/lazyload/lazyload.component' /* webpackChunkName: "scripts/hc_lazyload" */
                ).then(({ HcLazyload }) => {
                    HcLazyload.update()
                })
            })
            .catch(() => {
                $('[data-id="social-wall"]').html(IRISCollectionCustomer.irisSsoInstagramError)
            })
    }
})
